import { connect } from 'react-redux';
import { getAppName, getIsHotelOnly } from 'src/store/view/selectors';
import { MODULE_NAME } from 'src/constants';
import { touristErrorsSelector } from 'src/store/touristsValidation/selectors';
import { changeTouristData } from 'src/store/tourists/slice';
import { touristSelector } from 'src/store/tourists/selectors';
import { getActualizationShowModalCustomer } from 'src/routes/Checkout/store/selectors/actualization';
import { getCitizenshipCode } from 'src/routes/Checkout/store/selectors/data';
import { getAdultsCount } from '../../../../store/selectors/package';
import {
  validateTouristDataAction,
  validateTouristFieldAction,
  updateMockTouristAction,
} from '../../../../store/actions/tourists';
import { makeGetTouristErrors } from '../../../../store/selectors/validation';
import { getAllowDocsLater } from '../../../../store/selectors/order';
import { getAvailableVisaServices } from '../../../../store/domains/visa';
import withMobile from '../../hocs/withMobile';

import TouristForm from '../../../../../../components/Tourists/TouristForm';

export const mapStateToProps = () => {
  const getErrors = makeGetTouristErrors();

  return (state, props) => ({
    citizenshipCode: getCitizenshipCode(state, props.index),
    touristData: touristSelector(state, props.index),
    appName: getAppName(state),
    isHotelOnly: getIsHotelOnly(state),
    adults: getAdultsCount(state),
    visaServices: getAvailableVisaServices(state),
    allowDocsLater: !getIsHotelOnly(state) ? getAllowDocsLater(state) : false,
    // LT-25069: Типизировать selectors
    errors: getErrors(state, props.index),
    // в сторе заказов нет инфы для варнингов, так что пришлось сделать такой костыль чем костылить все селекторы
    isPackagePage: getAppName(state) === MODULE_NAME.PACKAGE_CHECKOUT,
    touristErrors: touristErrorsSelector(state, props.index),
    showModalCustomer: getActualizationShowModalCustomer(state),
  });
};

export const mapDispatchToProps = {
  setTouristsData: (tourist) => changeTouristData(tourist),
  validateTouristsData: (touristIdx) => validateTouristDataAction(touristIdx),
  validateTouristField: (payload) => validateTouristFieldAction(payload),
  updateMockTourist: (payload) => updateMockTouristAction(payload),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withMobile(TouristForm));
